import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { usePracticeAuth } from "../context/PracticeAuthContext";

// Gates on verificationStatus === 'APPROVED' — PENDING and REJECTED both
// bounce to the pending/status page, which explains which state they're in.
const PracticeApprovedRoute: React.FC = () => {
  const { practiceUser } = usePracticeAuth();

  if (practiceUser?.verificationStatus !== "APPROVED") {
    return <Navigate to="/speaking-partner/pending" replace />;
  }

  return <Outlet />;
};

export default PracticeApprovedRoute;
